import { useMutation, useQueryClient } from '@tanstack/react-query';
import { App } from 'antd';
import { useShallow } from 'zustand/shallow';

import { api } from '@/api';
import { END_POINT } from '@/constants/end-point.constants';
import { BILLING_INFORMATION_QUERY_KEYS } from '@/constants/query-keys.constants';
import { useCommonStore } from '@/store/common.store';

import type { BillingInformationRequest } from '../types';

const updateBillingInformation = (
  id: string,
  requestBody: BillingInformationRequest,
) => api.put(END_POINT.organizationBillingInformation(id), requestBody);

export const useUpdateBillingInformation = () => {
  const { message } = App.useApp();
  const queryClient = useQueryClient();
  const { setIsFormChanged, setIsProcessing, setIsFormUpdated } =
    useCommonStore(
      useShallow(({ setIsFormChanged, setIsProcessing, setIsFormUpdated }) => ({
        setIsFormChanged,
        setIsProcessing,
        setIsFormUpdated,
      })),
    );

  return useMutation({
    mutationFn: ({
      id,
      requestBody,
    }: {
      id: string;
      requestBody: BillingInformationRequest;
    }) => updateBillingInformation(id, requestBody),
    onMutate: () => setIsProcessing(true),
    onSettled: () => setIsProcessing(false),
    onSuccess: async (_, { id }) => {
      setIsFormChanged(false);
      setIsFormUpdated(true);
      await queryClient.invalidateQueries({
        queryKey: BILLING_INFORMATION_QUERY_KEYS.detail(id),
      });
      message.success('更新しました');
    },
  });
};
